<template>
    <a-config-provider :locale="locale">
        <template #renderEmpty>
            <div style="text-align: center">
                <img :src="img" alt="" width="230px" height="232px">
                <p style="color: #333333;">暂无数据</p>
            </div>
        </template>
        <div ref="app">
            <router-view v-if="isRouterAlive" :key="$route.fullPath" />
        </div>
    </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import _ from 'lodash'
import ResizeMix from '@/utils/resizemix.js' 

import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true,
            locale: zhCN,
            img: require('@/assets/images/basic/empty_order.png')
        }
    },
    mixins: [ResizeMix],
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        }
    },
}
</script>

<style>
html,
body {
    background-color: #F8F7F7 !important;
}

.clear {
    clear: both;
}

input[type='checkbox'] {
    display: none;
}

input[type='checkbox']+label {
    padding-left: 20px;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left center;
    cursor: pointer;
    background-image: url('./assets/images/basic/checkbox.png');
}

input[type='checkbox']:checked+label {
    background-image: url('./assets/images/basic/checkbox_checked.png');
}

.min_height {
    min-height: 860px !important;
} 
.main-box {
    margin: 20px;
    min-height: 280px;
    width: 100%;
    margin-right: 80px;
}

.ant-radio-inner::after {
    background-color: #fd5902 !important;
}

.ant-radio-checked .ant-radio-inner {
    border-color: #fd5902 !important;
}

.ant-btn-link {
    color: #ff6f02 !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #fd5902 !important;
    border-color: #fd5902 !important;
}

/deep/ .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #ffffff !important;
}

/deep/ table tbody tr:hover>td {
    background-color: #ffffff !important
}
</style>



// WEBPACK FOOTER //
// src/App.vue